import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { Provider as AppBridgeProvider } from "@shopify/app-bridge-react";
import { apolloClient } from "./apollo/client.js";
import { theme } from "./theme/theme.js";
import "./i18n/config.js";
import { App } from "./App.js";

// Shopify injects ?host=<base64> and ?shop=<domain> when loading the embedded app.
const params = new URLSearchParams(window.location.search);
const host = params.get("host") ?? "";
const apiKey = (import.meta.env.VITE_SHOPIFY_API_KEY as string | undefined) ?? "";

// forceRedirect: true — App Bridge handles the OAuth redirect automatically
// when the merchant hasn't installed the app yet.
const appBridgeConfig = { apiKey, host, forceRedirect: true };

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppBridgeProvider config={appBridgeConfig}>
      <ApolloProvider client={apolloClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </ApolloProvider>
    </AppBridgeProvider>
  </React.StrictMode>
);
